import DOMPurify from 'dompurify';

// HTML in messages comes from the server: the channel greeting, operator fragments the
// agent fills in, agent replies and HTML messages. It is shown sanitized (messageMarkdown.js
// for Markdown, sanitizeMessageHtml for raw HTML): no scripts, event handlers, iframes,
// forms, <style> or style attributes, and links only to http(s), mailto and tel. Its look
// comes from the channel's own message styles (channelSettings.messageCss, set per channel
// in the admin), and it may carry only the class names those styles define. In-message
// buttons keep their data-sure-* attributes.

export const BUTTON_DATA_ATTRIBUTES = [
  'data-sure-post',
  'data-sure-send-text',
  'data-sure-text',
  'data-sure-render',
  'data-sure-render-text',
];

// The class names a stylesheet's selectors use. Comments, strings and url()s are dropped
// first, so file names and hosts in them do not count as classes.
export const messageClassNames = (css) => {
  if (typeof css !== 'string' || !css) return [];
  const selectorsOnly = css
    .replace(/\/\*[\s\S]*?\*\//g, ' ')
    .replace(/url\([^)]*\)/gi, ' ')
    .replace(/"[^"]*"|'[^']*'/g, ' ');
  return [...new Set([...selectorsOnly.matchAll(/\.(-?[_a-zA-Z][\w-]*)/g)].map((m) => m[1]))];
};

// Elements nothing in a message needs, beyond what DOMPurify already removes.
const FORBID_TAGS = [
  'base',
  'embed',
  'form',
  'frame',
  'frameset',
  'iframe',
  'input',
  'link',
  'meta',
  'object',
  'option',
  'select',
  'style',
  'textarea',
];

// The class names the current sanitizeMessageHtml call allows; hooks are global.
let allowedClassNames = new Set();

DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName === 'class') {
    data.attrValue = data.attrValue
      .split(/\s+/)
      .filter((name) => allowedClassNames.has(name))
      .join(' ');
    if (!data.attrValue) data.keepAttr = false;
  } else if (data.attrName.startsWith('data-') && !BUTTON_DATA_ATTRIBUTES.includes(data.attrName)) {
    data.keepAttr = false;
  }
});

export const sanitizeMessageHtml = (html, classNames = []) => {
  if (!html) return '';
  allowedClassNames = new Set(classNames);
  try {
    return DOMPurify.sanitize(String(html), {
      FORBID_TAGS,
      FORBID_ATTR: ['style'],
      ADD_ATTR: ['target'],
    });
  } finally {
    allowedClassNames = new Set();
  }
};
